var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-tab",
    { attrs: { tab: _vm.tab } },
    [
      _vm.tab == 0
        ? _c("app-page-settings", {
            attrs: { layout: _vm.layout.PageSettings },
          })
        : _vm._e(),
      _vm.tab == 1
        ? _c("app-heading-settings", {
            attrs: { layout: _vm.layout },
            on: {
              "open-free-block": function ($event) {
                return _vm.onOpenFreeBlock($event)
              },
            },
          })
        : _vm._e(),
      _vm.tab == 2
        ? _c("app-logo-settings", { attrs: { logos: _vm.layout.Logos } })
        : _vm._e(),
      _vm.tab == 3
        ? _c("app-text-settings", { attrs: { layout: _vm.layout } })
        : _vm._e(),
      _vm.tab == 4
        ? _c("app-column-name-settings", {
            attrs: { "column-names": _vm.layout.ColumnNames },
          })
        : _vm._e(),
      _vm.tab == 5
        ? _c("app-free-line-settings", {
            attrs: { lines: _vm.layout.FreeLines },
          })
        : _vm._e(),
      _vm.tab == 6
        ? _c("app-free-block-settings", {
            attrs: {
              blocks: _vm.layout.FreeBlocks,
              layout: _vm.layout,
              "init-to-edit-free-block": _vm.toEditFreeBlock,
            },
          })
        : _vm._e(),
      _vm.tab == 12
        ? _c("app-pdf-preview", { attrs: { layout: _vm.layout } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }